import { TitleCasePipe } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-status-tag',
  template: `<div [class]="'rounded-full py-1.5 px-3 border text-xxs font-bold ' + colorVariants[statusTag]">
    {{ statusLabel | titlecase }}
  </div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TitleCasePipe],
})
export class StatusTagComponent {
  @Input() set status(value: string | undefined) {
    if (!value) {
      return;
    }

    switch (value.toLowerCase()) {
      case 'approved':
      case 'settled':
      case 'processing':
      case 'cleared':
      case 'active':
      case 'resolved':
        this.statusTag = 'success';
        break;

      case 'cancelled':
      case 'declined':
      case 'error':
        this.statusTag = 'danger';
        break;
      case 'new':
        this.statusTag = 'new';
        break;

      default:
        this.statusTag = 'warning';
    }

    this.statusLabel = value.replace(/_/gi, ' ');
  }

  colorVariants: Record<string, string> = {
    success: 'bg-status-success border-status-success',
    warning: 'bg-status-warning border-status-warning',
    danger: 'bg-status-danger border-status-danger',
    new: 'bg-white border-primary uppercase text-primary',
  };

  statusTag = '';

  statusLabel = '';
}
